import { useContext, useState } from "react";
import { AuthContext, DrawerContext } from "@CONTEXTS";
import { Alert, Button, Descriptions, Image, Modal, Spin } from "antd";
import { CopyElement } from "@UI";
import { useGET } from "@API2";
import { DeliveryEndpoints, getDeliveryPhotos, previewFile } from "@DELIVERIES";
const DeliveryDetail = () => {
  const { data } = useContext(DrawerContext);
  const { info } = useContext(AuthContext);
  const [photosLoading, setPhotosLoading] = useState(false);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [signedPhotos, setSignedPhotos] = useState([]);
  const [photosModalVisible, setPhotosModalVisible] = useState(false);
  const {
    data: apiData,
    loading,
    mutate,
  } = useGET(
    `${DeliveryEndpoints.getDeliveryTracking}/${data?.delivery?.customerDeliveryNo}/delivery-detail`,
    data?.delivery?.customerOrderId ? true : false
  );

  const handleGetDeliveryPhotos = async () => {
    setPhotosLoading(true);

    const response = await getDeliveryPhotos(
      apiData?.delivery?.customerDeliveryNo
    );

    if (!Array.isArray(response) || !response.length) {
      setPhotosLoading(false);
      return;
    }

    setSignedPhotos(response);
    setPhotosModalVisible(true);
    setPhotosLoading(false);
  };

  const handlePreviewInvoice = async () => {
    const portalDocName = apiData.metadata?.portalDocName;
    const barcode = apiData?.delivery?.customerDeliveryNo;
    if (!portalDocName || !barcode) {
      return;
    }

    setInvoiceLoading(true);
    try {
      const response = await previewFile(
        `deliveries/${barcode}/previewFile/${encodeURIComponent(portalDocName)}`
      );
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });
      const blobUrl = window.URL.createObjectURL(blob);
      window.open(blobUrl);
    } finally {
      setInvoiceLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <Spin tip="Yükleniyor" size="large" style={{ marginTop: 50 }}>
          <div className="content" />
        </Spin>
      ) : apiData?.delivery ? (
        <>
          {apiData?.recallMessage && (
            <h4 style={{ color: "red" }}>{apiData?.recallMessage}</h4>
          )}
          <Descriptions title={null} bordered column={1}>
            <Descriptions.Item label="Barkod">
              {apiData?.delivery?.customerDeliveryNo}
            </Descriptions.Item>
            <Descriptions.Item label="Sipariş Numarası">
              {apiData?.delivery?.customerOrderId}
            </Descriptions.Item>
            <Descriptions.Item
              label={
                apiData?.delivery?.deliveryType === "RETURNED"
                  ? "Teslim Alacak Kişi"
                  : "Alıcı Adı Soyadı"
              }
            >
              {apiData?.receiver?.receiver}
            </Descriptions.Item>
            <Descriptions.Item
              label={
                apiData?.delivery?.deliveryType === "RETURNED"
                  ? "Teslim Alacak Kişi Telefonu"
                  : "Alıcı Telefonu"
              }
            >
              {apiData?.receiver?.receiverGsm}
            </Descriptions.Item>
            <Descriptions.Item
              label={
                apiData?.delivery?.deliveryType === "RETURNED"
                  ? "Teslim Alacak Kişi Adresi"
                  : "Alıcı Adresi"
              }
            >
              {apiData?.receiver?.address} <br />
              {apiData?.receiver?.district
                ? `${apiData?.receiver?.district} / `
                : ""}{" "}
              {apiData?.receiver?.town} / {apiData?.receiver?.city}
            </Descriptions.Item>
            <Descriptions.Item
              label={
                apiData.delivery?.deliveryStatus !== "WAITING_FOR_DISPATCH" &&
                apiData?.product?.productCode !== "HX_ND"
                  ? "Söz Verilen Teslim Tarihi"
                  : "Teslim Alınacağı Tarih "
              }
            >
              {apiData.delivery?.deliveryDatePromised
                ? apiData.delivery?.deliveryDatePromised
                : apiData.delivery?.deliveryDateOriginal}
            </Descriptions.Item>
            {apiData.delivery?.deliveryStatusText === "Teslim Edildi" &&
              apiData.delivery?.deliveredDate && (
                <Descriptions.Item label="Gerçekleşen Teslimat Tarihi">
                  {apiData.delivery?.deliveredDate}
                </Descriptions.Item>
              )}

            {apiData?.delivery?.totalParcels && (
              <Descriptions.Item label="Parça Sayısı">
                {apiData?.delivery?.totalParcels}
              </Descriptions.Item>
            )}
            <Descriptions.Item label="Seçilen Desi">
              {apiData?.delivery?.desi}
            </Descriptions.Item>
            <Descriptions.Item label="HJ Desi">
              {apiData?.delivery?.hjDesi}
            </Descriptions.Item>
            {apiData?.delivery?.nonDeliveryReason && (
              <Descriptions.Item label="Teslim Edilememe Sebebi">
                {apiData?.delivery?.nonDeliveryReason}
              </Descriptions.Item>
            )}
            {apiData?.delivery?.nonReturnReason && (
              <Descriptions.Item label="İade Alınamama Sebebi">
                {apiData?.delivery?.nonReturnReason}
              </Descriptions.Item>
            )}
            {apiData?.delivery?.amount && (
              <Descriptions.Item label="Tahsilat Tutarı">
                {apiData?.delivery?.amount / 100} TL
              </Descriptions.Item>
            )}
            {apiData?.delivery?.deliveryType === "RETURNED" ? (
              <>
                <Descriptions.Item label="Teslim Alınacak Kişi">
                  {apiData?.sender?.sender}
                </Descriptions.Item>
                <Descriptions.Item label="Teslim Alınacak Kişi Telefonu">
                  {apiData?.sender?.senderGsm}
                </Descriptions.Item>
                <Descriptions.Item label="Teslim Alınacak Adres">
                  {apiData?.sender?.address}
                  <br />
                  {apiData?.sender?.district} / {apiData?.sender?.town} /{" "}
                  {apiData?.sender?.city}
                </Descriptions.Item>
              </>
            ) : (
              <Descriptions.Item label="Çıkış Deposu">
                {apiData?.warehouseName}
              </Descriptions.Item>
            )}
            <Descriptions.Item label="Gönderi Takip Linki">
              {
                <>
                  <a
                    href={
                      "https://hepsijet.com/gonderi-takibi/" +
                      apiData?.delivery?.customerDeliveryNo
                    }
                    target="_blank"
                  >
                    hepsijet.com/gonderi-takibi/
                    {apiData?.delivery?.customerDeliveryNo}
                  </a>
                  <CopyElement
                    text={
                      "https://hepsijet.com/gonderi-takibi/" +
                      apiData?.delivery?.customerDeliveryNo
                    }
                  />
                </>
              }
            </Descriptions.Item>
            {apiData.delivery?.deliveryStatusText === "Teslim Edildi" &&
              info?.specialTags?.includes("B2BPRO") && (
                <Descriptions.Item label="Teslim Formu">
                  <Button
                    type="link"
                    style={{ padding: 0 }}
                    loading={photosLoading}
                    onClick={handleGetDeliveryPhotos}
                  >
                    Görüntüle
                  </Button>
                </Descriptions.Item>
              )}
            {apiData.metadata?.portalDocName &&
              info?.specialTags?.includes("B2BPRO") && (
                <Descriptions.Item label="Fatura">
                  <Button
                    type="link"
                    style={{ padding: 0 }}
                    loading={invoiceLoading}
                    onClick={handlePreviewInvoice}
                  >
                    Görüntüle
                  </Button>
                </Descriptions.Item>
              )}
          </Descriptions>
          <Modal
            title="Teslim Formu Görüntüleme"
            visible={photosModalVisible}
            onCancel={() => setPhotosModalVisible(false)}
            footer={null}
            width={800}
          >
            <Image.PreviewGroup>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                  gap: 16,
                }}
              >
                {signedPhotos.map((photo) => (
                  <Image
                    key={photo.id}
                    src={photo.photoURL}
                    alt={photo.photoName || "signed-document"}
                    style={{ width: "100%" }}
                  />
                ))}
              </div>
            </Image.PreviewGroup>
          </Modal>
        </>
      ) : (
        <Alert showIcon type="info" message="Gönderi detayı getirilemedi." />
      )}
    </>
  );
};
export default DeliveryDetail;
